import { ajaxWrapper } from "functions";
import load_icon_from_monster from "pages/session_tools/global_data/load_icon_from_monster.js";
import create_icon_list from "pages/session_tools/global_data/create_icon_list.js";

function remove_monster_instance(id) {
	console.log("Remove Monster Instance", id);
	var instance_dict = window.secret_react_state.instances;
	var action_instance_dict = window.secret_react_state.action_instances;
	console.log("Remove Monster Instance", id, instance_dict[id], action_instance_dict[id]);

	if (
		window.secret_react_state.selected_monster_instance &&
		window.secret_react_state.selected_monster_instance.id == id
	) {
		window.secret_react_state.setGlobalState("selected_monster_instance", null);
	}

	if (instance_dict[id]) {
		delete instance_dict[id];
		window.secret_react_state.setGlobalState("instances", instance_dict);

		create_icon_list();
	}

	if (action_instance_dict[id]) {
		delete action_instance_dict[id];
		window.secret_react_state.setGlobalState("action_instances", action_instance_dict);
	}
}

export default remove_monster_instance;
